@for (menuItem of menuItems; track menuItem) {
  <div data-cy="side-bar-menu-item">
    @if (menuItem.children) {
      <div (click)="toggleExpanded(menuItem, $event)"
        [ngClass]="{'menu-item-active': isRouteActive(menuItem)}"
        [ngStyle]="{'padding-left': (depth * 12) + 'px'}"
        class="menu-item">
        <span [ngClass]="['menu-icon', menuItem.icon]" data-cy="side-bar-menu-item-icon"></span>
        <div class="menu-label">{{menuItem.label}}</div>
        <div class="collapse-icon"><span [ngClass]="getExpandedIcon(menuItem)" class="icon"></span></div>
      </div>
      @if (menuItem.isExpanded) {
        <div class="menu-child">
          <app-side-bar-menu-item [depth]="depth + 1"
          [menuItems]="menuItem.children"></app-side-bar-menu-item>
        </div>
        <div class="menu-separator"></div>
      }
    }
    @if (!menuItem.children) {
      <a [ngStyle]="{'padding-left': (depth * 12) + 'px'}" [routerLink]="menuItem.url" (click)="changeContext()"
        class="menu-item">
        <span [ngClass]="['menu-icon', menuItem.icon]"></span>
        <div class="menu-label">{{menuItem.label}}</div>
      </a>
    }
  </div>
}
